import api from "@/lib/api";

export async function monitoringEquipe(unidade, setor) {
  const { data } = await api.get("/secretaria-digital/monitoring/equipe", { params: { unidade, setor } })
  return data
}